<ion-header>
  <ion-toolbar>
    <ion-title [translate]="text"></ion-title>
  </ion-toolbar>
</ion-header>
